import SupportAgentIcon from "@mui/icons-material/SupportAgent";
import { Stack, Typography } from "@mui/material";
import { type FC } from "react";

const MARK_BG = "#9a3412";

/** Loud mark for tasks reserved for call-center volunteers. */
export const CallCenterVolunteerAssignmentMark: FC<{
  /** Compact line inside a table cell, or a page banner. */
  layout?: "row" | "banner";
  /** Station operators work these tasks, so the copy does not tell them to leave it. */
  forStation?: boolean;
}> = ({ layout = "row", forStation = false }) => {
  const text = forStation
    ? "במאגר מתנדבי המוקד"
    : layout === "banner"
      ? "המשימה משויכת למתנדבי המוקד. אין לטפל בה."
      : "משויך למתנדבי המוקד · אין לטפל";

  return (
    <Stack
      direction="row"
      alignItems="center"
      gap={0.75}
      role="status"
      sx={{
        alignSelf: "stretch",
        mx: layout === "banner" ? 2 : 0,
        mb: layout === "banner" ? 1.5 : 0,
        px: layout === "banner" ? 1.5 : 1,
        py: layout === "banner" ? 1.25 : 0.7,
        borderRadius: layout === "banner" ? "0.75rem" : 1,
        bgcolor: MARK_BG,
        color: "#fff",
        boxShadow: "inset 0 0 0 1px rgba(255,255,255,0.18)",
      }}
    >
      <SupportAgentIcon sx={{ fontSize: layout === "banner" ? 22 : 18, flexShrink: 0 }} />
      <Typography
        component="span"
        sx={{
          color: "inherit",
          fontWeight: 800,
          fontSize: layout === "banner" ? "0.95rem" : "0.8rem",
          lineHeight: 1.35,
        }}
      >
        {text}
      </Typography>
    </Stack>
  );
};
